import {useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import PasswordChangeBox from "../../components/PasswordChangeBox";
import {MyContext} from "../../context/myContext";
import {useDispatch, useSelector} from "react-redux";
import {handleShowTopMenuPasswordForm, postTopMenuPasswordForm, selectShowTopMenuPasswordForm} from "./topMenuSlice";

const data = [
    {id: 'icon1', name: 'currentPass', label: 'رمز عبور فعلی'},
    {id: 'icon2', name: 'newPass', label: 'رمز عبور جدید'},
    {id: 'icon3', name: 'repeatNewPass', label: 'تکرار رمز عبور'},
]

const TopMenu = () => {
    const initialPasswords = {currentPass: '', newPass: '', repeatNewPass: ''}
    const initialShowPass = {icon1: false, icon2: false, icon3: false}
    const [showDropDown, setShowDropDown] = useState(false)
    const navigate =useNavigate();
    const dispatch = useDispatch()
    const showTopMenuPasswordForm = useSelector(selectShowTopMenuPasswordForm)

    let ref = useRef(null)
    const handleShowDropdown = () => {
        setShowDropDown(!showDropDown)
    }
    const handleShowPasswordForm = () => {
        dispatch(handleShowTopMenuPasswordForm(!showTopMenuPasswordForm))
    }
    const handleClosePopup = () => {
        if(showTopMenuPasswordForm === true){
            dispatch(handleShowTopMenuPasswordForm(false))
        }
    }
    const handleExit = () => {
        navigate('/')
    }
    const handleSubmit = (currentPass, newPass) => {
        const data = {
            current_password: currentPass,
            new_password: newPass
        }
        dispatch(postTopMenuPasswordForm({data, dispatch}))
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if(ref.current && !ref.current.contains(event.target)){
                setShowDropDown(false)
            }
        }
        document.addEventListener('click', handleClickOutside, true)
        return() => {
            document.removeEventListener('click', handleClickOutside, true)
        }
    }, [])

    return(
        <div className='sticky flex justify-between items-center h-[8vh] p-3 shadow-xl z-10'>
            <div className='ml-2 sm:ml-4 md:ml-6 lg:ml-10 border-r border-r-1 border-r-slate-400 py-3 pr-2 cursor-pointer relative' onClick={handleShowDropdown}>
                <span ref={ref}><span className="text-base sm:text-lg">{localStorage.getItem('userName')}</span><i className="fa fa-solid fa-user text-xl ml-2 text-greenColor user-icon"></i></span>
                <div className={`${showDropDown && 'border-b border-b-1 border-b-borderColor h-[80px]'} absolute -left-[25px] top-14 bg-white text-right h-0 w-[120px] overflow-hidden border-x border-x-1 border-x-borderColor border-y-none rounded-b-md transition-all duration-500`}>
                    <p className='px-2 pb-4 cursor-pointer text-sm mx-1 border-b border-b-1 border-b-slate-400 hover:text-greenColor' onClick={handleShowPasswordForm}>تغییر رمز عبور</p>
                    <span className='px-2 pb-4 cursor-pointer text-sm hover:text-greenColor' onClick={handleExit}>خروج</span>
                </div>
            </div>
            <div className='mr-0 sm:mr-3 flex items-center'><span className='text-sm sm:text-base md:text-lg'>سامانه مدیریت آبرسانی عشایر</span><img alt='office-icon' className='w-[40px] h-[30px] md:w-[50px] md:h-[40px]' src='/Untitled.jpg' /></div>
            <div className={`${showTopMenuPasswordForm && 'visible bg-slate-700 opacity-50'} dark-background`} onClick={handleClosePopup}></div>
            <MyContext.Provider value={{handleShowForm: handleShowPasswordForm, showTopMenuPasswordForm, data, initialPasswords, initialShowPass, handleSubmit, formTitle: 'تغییر رمزعبور'}}>
                <PasswordChangeBox />
            </MyContext.Provider>
        </div>
    )
}

export default TopMenu